import * as ActionTypes from './actionTypes';
import * as MessageActions from '../../common/messageBox/actions/actions';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const fetchMailGroupList = () =>
  apiActionCreator({
    'endpoint': '/mail/groups',
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_MAIL_GROUP_LIST,
      ActionTypes.FETCHED_MAIL_GROUP_LIST,
      [
        ActionTypes.FETCHED_MAIL_GROUP_LIST_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });

export const fetchInternalUsersByGroup = (group) =>
  apiActionCreator({
    'endpoint': `/mail/internal-users/${group}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_INTERNAL_USERS_LIST_BY_GROUP,
      ActionTypes.FETCHED_INTERNAL_USERS_LIST_BY_GROUP,
      [
        ActionTypes.FETCHED_INTERNAL_USERS_LIST_BY_GROUP_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });

export const fetchExternalUsersByGroup = (group) =>
  apiActionCreator({
    'endpoint': `/mail/external-users/${group}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_EXTERNAL_USERS_LIST_BY_GROUP,
      ActionTypes.FETCHED_EXTERNAL_USERS_LIST_BY_GROUP,
      [
        ActionTypes.FETCHED_EXTERNAL_USERS_LIST_BY_GROUP_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
  
export const fetchMailGroupInfoByGroup = (group) =>
  apiActionCreator({
    'endpoint': `/mail/groups/${group}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_MAIL_GROUP_INFO_BY_GROUP,
      ActionTypes.FETCHED_MAIL_GROUP_INFO_BY_GROUP,
      [
        ActionTypes.FETCHED_MAIL_GROUP_INFO_BY_GROUP_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });

export const addNewGroupInfo = (data = {}) =>
  apiActionCreator({
    'endpoint': '/mail/groups',
    'authenticated': true,
    'types': [
      ActionTypes.ADDING_NEW_GROUP_INFO,
      [
        ActionTypes.ADDED_NEW_GROUP_INFO,
        MessageActions.addMessageBoxInfo('Nuevo  grupo de correo agregado exitosamente.'),
      ],
      [
        ActionTypes.ADDED_NEW_GROUP_INFO_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'POST',
    'contentType': 'application/json',
    'data': data,
  });

export const updateGroupInfo = (group, data = {}) =>
  apiActionCreator({
    'endpoint': `/mail/groups/${group}`,
    'authenticated': true,
    'types': [
      ActionTypes.UPDATING_NEW_GROUP_INFO,
      [
        ActionTypes.UPDATED_NEW_GROUP_INFO,
        MessageActions.addMessageBoxInfo('Grupo de Correo actualizado.'),
      ],
      [
        ActionTypes.UPDATED_NEW_GROUP_INFO_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'PUT',
    'contentType': 'application/json',
    'data': data,
  });

export const addInternalUserByGroup = (group, data = {}) =>
  apiActionCreator({
    'endpoint': `/mail/internal-users/${group}`,
    'authenticated': true,
    'types': [
      ActionTypes.ADDING_NEW_INTERNAL_USER_BY_GROUP,
      [
        ActionTypes.ADDED_NEW_INTERNAL_USER_BY_GROUP,
        MessageActions.addMessageBoxInfo('Usuario interno agregrado exitosamente.'),
      ],
      [
        ActionTypes.ADDED_NEW_INTERNAL_USER_BY_GROUP_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'POST',
    'contentType': 'application/json',
    'data': data,
  });

export const addExternalUserByGroup = (group, data = {}) =>
  apiActionCreator({
    'endpoint': `/mail/external-users/${group}`,
    'authenticated': true,
    'types': [
      ActionTypes.ADDING_NEW_EXTERNAL_USER_BY_GROUP,
      [
        ActionTypes.ADDED_NEW_EXTERNAL_USER_BY_GROUP,
        MessageActions.addMessageBoxInfo(
          'Usuario externo agregrado exitosamente.'
        ),
      ],
      [
        ActionTypes.ADDED_NEW_EXTERNAL_USER_BY_GROUP_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'POST',
    'contentType': 'application/json',
    'data': data,
  });

export const deleteInternalUserByGroup = (group, username) =>
  apiActionCreator({
    'endpoint': `/mail/internal-users/${group}/${username}`,
    'authenticated': true,
    'types': [
      ActionTypes.DELETING_INTERNAL_USER_BY_GROUP,
      [
        ActionTypes.DELETED_INTERNAL_USER_BY_GROUP,
        MessageActions.addMessageBoxInfo('Usuario interno eliminado.'),
      ],
      [
        ActionTypes.DELETED_INTERNAL_USER_BY_GROUP_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'DELETE',
  });

export const deleteExternalUserByGroup = (group, email) =>
  apiActionCreator({
    'endpoint': `/mail/external-users/${group}/${email}`,
    'authenticated': true,
    'types': [
      ActionTypes.DELETING_EXTERNAL_USER_BY_GROUP,
      [
        ActionTypes.DELETED_EXTERNAL_USER_BY_GROUP,
        MessageActions.addMessageBoxInfo('Usuario externo eliminado.'),
      ],
      [
        ActionTypes.DELETED_EXTERNAL_USER_BY_GROUP_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'DELETE',
  });

export const updateAllInternalUserByGroup = (group, data = {}) =>
  apiActionCreator({
    'endpoint': `/mail/internal-users/${group}`,
    'authenticated': true,
    'types': [
      ActionTypes.UPDATING_ALL_INTERNAL_USER_BY_GROUP,
      [
        ActionTypes.UPDATED_ALL_INTERNAL_USER_BY_GROUP,
        MessageActions.addMessageBoxInfo('Usuarios internos actualizados'),
      ],
      [
        ActionTypes.UPDATED_ALL_INTERNAL_USER_BY_GROUP_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'PUT',
    'contentType': 'application/json',
    'data': data,
  });

export const updateAllExternalUserByGroup = (group, data = {}) =>
  apiActionCreator({
    'endpoint': `/mail/external-users/${group}`,
    'authenticated': true,
    'types': [
      ActionTypes.UPDATING_ALL_EXTERNAL_USER_BY_GROUP,
      [
        ActionTypes.UPDATED_ALL_EXTERNAL_USER_BY_GROUP,
        MessageActions.addMessageBoxInfo('Usuarios externos actualizados'),
      ],
      [
        ActionTypes.UPDATED_ALL_EXTERNAL_USER_BY_GROUP_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'PUT',
    'contentType': 'application/json',
    'data': data,
  });

export const clearInternalUsersList = () => ({
  'type': ActionTypes.CLEAR_INTERNAL_USERS_LIST,
});

export const clearExternalUsersList = () => ({
  'type': ActionTypes.CLEAR_EXTERNAL_USERS_LIST,
});

export const setMailGroupField = () => ({
  'type': ActionTypes.SET_MAIL_GROUP_FIELD,
});

export const updateInternalUserList = (index, data = {}) => ({
  'type': ActionTypes.UPDATE_INTERNAL_USER_LIST,
  'payload': {index, data},
});

export const updateExternalUserList = (index, data = {}) => ({
  'type': ActionTypes.UPDATE_EXTERNAL_USER_LIST,
  'payload': {index, data},
});
